export const parseVerseParam = (param) => {
  if (!param) return null;
  const str = String(param).trim();
  if (!str) return null;

  if (str.includes("-")) {
    const parts = str.split("-").map((p) => Number(p.trim())).filter((n) => Number.isFinite(n) && n > 0);
    if (parts.length >= 2) {
      return {
        start: Math.min(parts[0], parts[1]),
        end: Math.max(parts[0], parts[1]),
      };
    }
  }

  const single = Number(str);
  if (Number.isFinite(single) && single > 0) {
    return {
      start: single,
      end: single,
    };
  }

  return null;
};

export const buildShareUrl = (editionId, chapterId, startVerse, endVerse) => {
  if (!chapterId || !startVerse) return "";
  const origin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
  const vParam = startVerse === endVerse || !endVerse ? `${startVerse}` : `${startVerse}-${endVerse}`;

  let path = "";
  if (editionId === "en") {
    path = `/en/chapter/${chapterId}?v=${vParam}`;
  } else if (editionId === "compare") {
    path = `/compare/chapter/${chapterId}?v=${vParam}`;
  } else {
    path = `/chapter/${chapterId}?v=${vParam}`;
  }

  return origin ? `${origin}${path}` : path;
};
